import { render, staticRenderFns } from "./itSupportHomePageCard.vue?vue&type=template&id=09d443b7&scoped=true&"
import script from "./itSupportHomePageCard.vue?vue&type=script&lang=js&"
export * from "./itSupportHomePageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d443b7",
  null
  
)

export default component.exports